import { colors } from '../styles/colors';

/**
 * Composant d'en-tête de page réutilisable
 *
 * @param {Object} props
 * @param {React.ComponentType} props.icon - Composant d'icône Lucide React
 * @param {string} props.title - Titre principal de la page
 * @param {string} props.subtitle - Sous-titre/description de la page
 * @param {React.ReactNode} [props.actions] - Boutons d'action à droite (optionnel)
 * @param {string} [props.iconBgColor] - Couleur de fond de l'icône (défaut: colors.primary.gold)
 * @param {string} [props.iconColor] - Couleur de l'icône (défaut: colors.text.white)
 * @param {number} [props.iconSize] - Taille de l'icône (défaut: 28)
 */
function PageHeader({
  icon: Icon,
  title,
  subtitle,
  actions,
  iconBgColor = colors.primary.gold,
  iconColor = colors.text.white,
  iconSize = 28
}) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      paddingBottom: '1rem',
      borderBottom: `2px solid ${colors.primary.teal}`,
      marginBottom: '1.5rem'
    }}>
      {/* Icône */}
      <div style={{
        backgroundColor: iconBgColor,
        padding: '0.75rem',
        borderRadius: '0.75rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Icon size={iconSize} color={iconColor} />
      </div>

      {/* Titre et sous-titre */}
      <div style={{ flex: 1 }}>
        <h1 style={{
          margin: 0,
          fontFamily: '"Century Gothic Bold", "Noto Sans", sans-serif',
          fontSize: '1.25rem',
          color: colors.primary.gray,
          fontWeight: 'bold'
        }}>
          {title}
        </h1>
        <p style={{
          margin: '0.25rem 0 0 0',
          fontSize: '0.875rem',
          color: colors.secondary.mediumGray,
          fontFamily: '"Noto Sans", sans-serif'
        }}>
          {subtitle}
        </p>
      </div>

      {/* Actions optionnelles */}
      {actions && (
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          {actions}
        </div>
      )}
    </div>
  );
}

export default PageHeader;
